import React from "react"

import {  Wrapper, Background, Padder, RichText } from 'components'

import {Layout, Viewport, BlockDescription} from "../../components"
import { getBlockDescriptionProps } from '../../utility'

import theme from '../../style/theme'

export default (props) => {

  const { translations, siteMetadata } = props.pageContext

  const { blockDescription_2, richText_2 } = translations
  const { pathPrefix} = siteMetadata

  return (
  <Layout {...props}>
    <Wrapper size="large">
    <Padder size="big">
      <RichText text={richText_2} />
    </Padder>

    </Wrapper>
    {blockDescription_2.map((item, index) => (
      <Background color={index % 2 ? "white" : theme.colors.lightGray.secondary} key={`${item.title}${index}`}>
          <Wrapper size="large">
            <Padder size="big">
            <Viewport>
              {({isVisible}) => {
                const props = getBlockDescriptionProps({item, index, pathPrefix})
                return <BlockDescription {...props} />
              }}
              </Viewport>
            </Padder>
          </Wrapper>
        </Background>
      ))}
  </Layout>
)}